import { filter } from 'rxjs/operators';
import { Router, NavigationEnd } from '@angular/router';
import { ImportConfigurationDTO, ImportConfigurationTransferType, FilterDTO, FilterOperator, ImportType, ImportConfigurationType, ImportConfigurationClientAccessType } from '../../../base/models/models.swagger.generated';
import { AvpCustomAdaptor } from '../../../base/shared/syncfusion/avp-custom-adaptor';
import { DataManager } from '@syncfusion/ej2-data';
import { SpinnerService } from 'src/app/base/spinner/spinner.service';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { Component, OnInit, ViewChild } from '@angular/core';
import { RowSelectEventArgs, GridModule } from '@syncfusion/ej2-angular-grids';
import { CreateConfigurationUtil } from '../shared/create-configuration.util';
import { importConfigurationGlobalRoute, importConfigurationGlobalCreateRoute} from 'src/app/core/routing/route-names';
import { QueryBuilderModule } from '@syncfusion/ej2-angular-querybuilder';
import { ToolbarModule } from '@syncfusion/ej2-angular-navigations';
import { TitleBarComponent } from '../../../base/shared/title-bar/title-bar.component';
import * as pages from '../../../core/routing/page-names';
import { UrlHelper } from 'src/app/base/shared/url-helper';
import { GridConstantsFactory } from 'src/app/base/shared/syncfusion/grid-constants-factory';
import { CheckBoxModule } from '@syncfusion/ej2-angular-buttons';
import { AuthService } from 'src/app/base/services/auth.service';
import { DialogComponent, DialogModule } from '@syncfusion/ej2-angular-popups';
import { getNavisionTempalteIcon } from '../shared/import-configuration.util';
import { IImportConfigurationEditSettings, ImportConfigurationEditFormsComponent } from '../shared/import-configuration-edit-forms/import-configuration-edit-forms.component';
import { ImportTypeEnumFilter } from '../import-type-enum-filter';
import { ImportConfigurationGlobalService } from './import-configuration-global.service';
import { ImportConfigurationTemplatesComponent } from '../import-configuration/import-configuration-templates/import-configuration-templates.component';
import { GridBaseComponent } from 'src/app/base/shared/grid-base/grid-base.component';
import { BehaviorSubject, of } from 'rxjs';
import { CommonModule } from '@angular/common';
import { ImportConfigurationEditFormsCoordinatorService } from '../shared/import-configuration-edit-forms/import-configuration-edit-forms-coordinator.service';

@Component({
    selector: 'app-import-configuration-global',
    templateUrl: './import-configuration-global.component.html',
    styleUrls: ['./import-configuration-global.component.scss'],
    imports: [TitleBarComponent,
        GridModule,
        ToolbarModule,
        QueryBuilderModule,
        ImportConfigurationEditFormsComponent,
        TranslateModule,
        CheckBoxModule,
        DialogModule,
        ImportConfigurationTemplatesComponent,
        CommonModule
    ]
})
export class ImportConfigurationGlobalComponent extends GridBaseComponent<any> implements OnInit {

  @ViewChild(ImportConfigurationEditFormsComponent)
  public configurationEditForm: ImportConfigurationEditFormsComponent;

  @ViewChild(DialogComponent)
  public templateDialog: DialogComponent;

  public configurationEditSettings : IImportConfigurationEditSettings =  {
    importConfigurationRoute: importConfigurationGlobalRoute,
    importConfigurationPageName: pages.importConfigurationsGlobalPageName,
    supportResponseConfig: false,
  };

  public TransferType = ImportConfigurationTransferType;
  public ImportType = ImportType;

  public checkBoxFilter = GridConstantsFactory.createCheckBoxFilter();

  //Selected template
  private selectedTemplateSubject = new BehaviorSubject<ImportConfigurationDTO | null>(null);
  public selectedTemplate$ = this.selectedTemplateSubject.asObservable();

  public get selectedTemplate(): ImportConfigurationDTO | null {
    return this.selectedTemplateSubject.value;
  }

  private set selectedTemplate(value: ImportConfigurationDTO | null) {
    this.selectedTemplateSubject.next(value);
  }
  //

  //Configuration
  private configurationSubject = new BehaviorSubject<ImportConfigurationDTO | null>(null);
  public configuration$ = this.configurationSubject.asObservable();

  public get configuration(): ImportConfigurationDTO | null {
    return this.configurationSubject.value;
  }

  public set configuration(value: ImportConfigurationDTO | null) {
    this.configurationSubject.next(value);
  }
  //

  private previousRowIndex: number;

  constructor(
    translateService: TranslateService,
    private router: Router,
    private service: ImportConfigurationGlobalService,
    private spinnerService: SpinnerService,
    private authService: AuthService,
    private formsCoordinationService: ImportConfigurationEditFormsCoordinatorService) {
    super(translateService, service);
  }

  public ngOnInit() {
    //Set initial filter when navigating over url
    var id = UrlHelper.getIdForSegment(pages.importConfigurationsGlobalPageName, this.router);
    if (id != null && id != undefined) {
      this.service.setOneTimeFilter(new FilterDTO({ isComplex: false, field: 'id', operator: FilterOperator.Equal, value: id.toString() }));
    }

    this.data = new DataManager({
      adaptor: new AvpCustomAdaptor(this.service, this.spinnerService)
    });

    this.isActiveColumnName = 'configurationName';
    this.addIndexFindColumnName = 'configurationName';

    this.router.events.pipe(filter(event => event instanceof NavigationEnd && event.url.includes(importConfigurationGlobalRoute || importConfigurationGlobalCreateRoute) && !event.url.includes(pages.importConfigurationsResponsePageName))).subscribe(() => {
      this.urlChanged();
    });
  }

  public urlChanged(): void {
    var id = UrlHelper.getIdForSegment(pages.importConfigurationsGlobalPageName, this.router);
    if (this.router.url.startsWith(importConfigurationGlobalCreateRoute)) {
      //prevents creation when navigating over url because in this case the client is never set
      if (!this.authService.isUserAdmin()) {
        this.router.navigate([importConfigurationGlobalRoute]);
      }
      if (this.configuration == null) {
        this.createConfiguration();
      }
    } else if (id != null) {
      this.service.getConfigurationById(+id).subscribe(data => {
        this.configuration = data;
      });
    } else {
      this.configuration = null;
      if (this.grid?.selectedRowIndex >= 0) {
        this.grid.selectRows([]);
      }
    }
  }

  public dataBound(): void {
    var id = UrlHelper.getIdForSegment(pages.importConfigurationsGlobalPageName, this.router);
    if (id != null) {
      this.grid.selectRow(this.grid.getRowIndexByPrimaryKey(id));
    }
    this.urlChanged();
  }

  public addConfiguration(): void {
    if (!this.authService.isUserAdmin()) {
      return;
    }
    (this.configurationEditForm ? this.configurationEditForm.canCloseForm() : of(true)).subscribe((canClose: boolean) => {
      if (!canClose) {
        return;
      }

      this.createConfiguration();
      this.router.navigate([importConfigurationGlobalCreateRoute]);
    });
  }

  public duplicateConfiguration(): void {
    if (!this.configuration) {
      return;
    }
    this.configurationEditForm.canCloseForm().subscribe((canClose: boolean) => {
      if (!canClose) {
        return;
      }
      this.configuration = this.configurationEditForm.duplicateActualConfiguration();
      this.configuration.type = ImportConfigurationType.Configuration;
      this.configuration.clientAccessType = ImportConfigurationClientAccessType.Global;
      this.grid.selectRows([]);
      this.router.navigate([importConfigurationGlobalCreateRoute]);
    });
  }

  public onRowSelected(args: RowSelectEventArgs): void {
    (this.configurationEditForm ? this.configurationEditForm.canCloseForm() : of(true)).subscribe((canClose: boolean) => {
      if (!canClose) {
        this.grid.selectRows([this.previousRowIndex]);
        return;
      }
      const id = (args.data as ImportConfigurationDTO)?.id;
      if (!id) {
        return;
      }

      var importConfigId = UrlHelper.getIdForSegment(pages.importConfigurationsGlobalPageName, this.router);
      if (importConfigId == id) {
        //dont redirect, url is already correct
        return;
      }

      this.router.navigate([importConfigurationGlobalRoute + "/" + id + "/" + pages.configurationGeneralPageName]);
      this.previousRowIndex = this.grid?.selectedRowIndex;
    });
  }

  public onSaveConfiguration(configuration: ImportConfigurationDTO) {
    if (configuration.id === 0) {
      this.service.addRecord(configuration).subscribe({
        next: () => {
          this.configuration = null;
          this.grid.refresh();
          this.router.navigate([importConfigurationGlobalRoute]);
        },
        error: () => {
          // Handled in service
        }
      });
    } else {
      this.service.updateRecord(configuration).subscribe({
        next: () => {
          this.configuration = null;
          this.grid.refresh();
          this.router.navigate([importConfigurationGlobalRoute]);
        },
        error: () => {
          // Handled in service
        }
      });
    }
  }

  public onDelete(id: number) {
    this.service.deleteRecord(id).subscribe(() => {
      this.configuration = null;
      this.router.navigate([importConfigurationGlobalRoute]);
      this.grid.refresh();
    });
  }

  public onCancel() {
    this.configuration = null;
    this.grid.selectRows([]);
    this.router.navigate([importConfigurationGlobalRoute]);
  }

  public getTransferTypeName(transferType: number): string {
    return 'i18n.shared.import-config-transfer-types.' + ImportConfigurationTransferType[transferType];
  }

  public formatFilterImportType(importTypeEnumFilter: ImportTypeEnumFilter): string {
    if (!importTypeEnumFilter) {
      return '';
    }
    return this.translateService.instant('i18n.shared.import-types.' + ImportType[importTypeEnumFilter.importType]);
  }

  protected initializeEditForm(data: any): void {
    throw new Error('Method not implemented.');
  }

  protected getEditDialogTitleParams(rowData: any): object {
    throw new Error('Method not implemented.');
  }

  public addAllowed(): boolean {
    return this.authService.isUserAdmin();
  }

  public templateSelectedAndClose(args: any): void {
    this.onTemplateSelected(args);
    this.onTemplateOkClicked();
  }

  public onTemplateCancelClicked(): void {
    this.selectedTemplate = null;
    this.templateDialog.hide();
  }

  public onTemplateSelected(args) {
    this.service.getConfigurationById(args.id).subscribe(data => {
      data.clientAccessType = ImportConfigurationClientAccessType.Global;
      this.selectedTemplate = data;
    });
  }

  public onTemplateOkClicked(): void {
    this.configuration = this.formsCoordinationService.copyFromTemplate(this.selectedTemplate);
    this.configuration.clientAccessType = ImportConfigurationClientAccessType.Global;
    this.configuration.client = null;

    // STARGATE-254 requested new configuration should be inactive
    this.configuration.isActive = false;

    this.grid.selectRows([]);
    this.router.navigate([importConfigurationGlobalCreateRoute]);
    this.selectedTemplate = null;
    this.templateDialog.hide();
  }

  public openTemplateDialog(): void {
    this.selectedTemplate = null;
    this.templateDialog.show();
  }

  public getNavisionTempalteIcon(config: ImportConfigurationDTO): string {
    return getNavisionTempalteIcon(config);
  }

  public getClientName(data: ImportConfigurationDTO): string {
    if(data.client) {
      return data.client?.name + ' (' + ( data.client?.customerNumber ?? data.client?.vendorNumber) + ')';
    }
    return '';
  }

  private createConfiguration(): void {
    this.configuration = CreateConfigurationUtil.createNewImportConfigurationDTO(null);
    this.configuration.configurationName = 'New Global Configuration';
    this.configuration.type = ImportConfigurationType.Configuration;
    this.configuration.clientAccessType = ImportConfigurationClientAccessType.Global;
    this.configuration.transferType = ImportConfigurationTransferType.ManualImport;
    this.configuration.fileConfig.sendResponse = false;
  }

}
